export enum JackpotSymbols {
  Club = 1,
  Diamond = 2,
  Heart = 3,
  Spade = 4
}

export enum JackpotTierName {
  Club = 'CLUB',
  Diamond = 'DIAMOND',
  Heart = 'HEART',
  Spade = 'SPADE'
}

export const JackpotSymbolsToName: { [key in JackpotSymbols]: JackpotTierName } = {
  [JackpotSymbols.Club]: JackpotTierName.Club,
  [JackpotSymbols.Diamond]: JackpotTierName.Diamond,
  [JackpotSymbols.Heart]: JackpotTierName.Heart,
  [JackpotSymbols.Spade]: JackpotTierName.Spade
};
